import { filmSources, type ProductFrame } from '@/lib/productFrames';

interface FilmSourcesProps {
  frame: ProductFrame;
  /** Media-fragment start applied to every source. */
  startAt: number;
  /** Every source failed: the browser could not load or decode any encode. */
  onAllFailed: () => void;
}

/**
 * The `<source>` children of a film player: VP9 WebM first, then the H.264
 * MP4 fallback. A failed source fires `error` on itself, not on the video,
 * and the browser moves on to the next one, so only the LAST source's error
 * means nothing will play. A decode error after loading still fires on the
 * video element, which keeps its own `onError` — and must ignore errors whose
 * target is a source, because React bubbles them up to the video's handler.
 */
export function FilmSources({ frame, startAt, onAllFailed }: Readonly<FilmSourcesProps>) {
  const sources = filmSources(frame);
  return (
    <>
      {sources.map((source, index) => (
        <source
          key={source.src}
          src={`${source.src}#t=${startAt}`}
          type={source.type}
          onError={index === sources.length - 1 ? onAllFailed : undefined}
        />
      ))}
    </>
  );
}
